export default "__VITE_ASSET__L0Jxbjeg__"